<script setup lang="ts">
import PageHeader from "@/layouts/partials/marketing/PageHeader.vue";

const data = await useSeoAndGetContent(ROUTES.termsAndConditions);
const { headerDescription, headerTitle, breadcrumbTitle, _path: slug } = data;

definePageMeta({
  layout: "marketing",
});
</script>

<template>
  <div>
    <PageHeader :pageData="{ slug, breadcrumbTitle, headerTitle, headerDescription }" />
    <div class="flex flex-col">
      <section class="mx-auto max-w-7xl prose">
        <ContentRenderer :value="data" />
      </section>
    </div>
  </div>
</template>
